import logo from "./logo.svg";
import "./App.css";

function App() {
  return <div className="App">Hello this is updated reporting page</div>;
}

export default App;
